import { CollectionViewer } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, from, Observable } from 'rxjs';
import { Category } from 'src/app/Models/category';
import { Policy } from 'src/app/Models/policy';
import { UserInfo } from 'src/app/Models/user-info';
import { CategoryService } from 'src/app/Services/category.service';
import { UserService } from 'src/app/Services/user.service';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CategoryForm } from 'src/app/Models/category-form';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css']
})
export class CategoryComponent implements OnInit {
  currentUserInfo : UserInfo;
  userType: string;
  userName: string;
  categoryList : Category[];
  policyList : Policy[];
  category = new FormControl();
  categoryID = new FormControl();
  private apiCall = '/getcategorypolicylist/';
  message: string;
  
  displayedColumns = ["seqNo", "description", "status", "action"];
  private categorySubject = new BehaviorSubject<Category[]>([]);
  
  addCategoryForm : FormGroup;
  isDisabled:boolean = true;

  constructor(private categoryService: CategoryService
          , private userService: UserService) { }

  ngOnInit(): void {
    this.currentUserInfo = this.userService.getCurrentUserInfo();
    console.log("currentUserInfo: " + JSON.stringify(this.currentUserInfo));
    if (this.currentUserInfo !== undefined && this.currentUserInfo !== null && Object.keys(this.currentUserInfo).length > 0) {
      this.userType = this.currentUserInfo.userType;
      this.userName = this.currentUserInfo.userName;
      this.getCategoryPolicies(this.currentUserInfo.userPNumber);
    }
  }

  enableAddButton() {
    var categoryString = (<HTMLInputElement>document.getElementById("category")).value;
    if (categoryString.length >= 5) {
      (<HTMLInputElement>document.getElementById("addCategoryButton")).disabled = false;
    }
    else {
      (<HTMLInputElement>document.getElementById("addCategoryButton")).disabled = true;
    }
  }

  AddCategory() {
    var content = new CategoryForm();

    content.UserPNumber = this.currentUserInfo.userPNumber;
    content.Description = this.category.value;
    // content.Description = this.addCategoryForm.get("category").value;
    this.categoryService.addCategory('/spcategoryadd', content).subscribe(
      data => {
        this.categoryList = data['categories'];
        this.policyList = data['policies'];
        this.category.setValue('');
        this.message = 'Category added.';
        //return data;
      }
    );
  }

  updateCategory(cID) {
    var content = new CategoryForm();

    content.UserPNumber = this.currentUserInfo.userPNumber;
    content.CategoryID = cID;
    content.Description = (<HTMLInputElement>document.getElementById("description_" + cID)).value;
    content.Active = (<HTMLInputElement>document.getElementById("status_" + cID)).value;
    this.categoryService.addCategory('/spcategoryupdate', content).subscribe(
      data => {
        this.categoryList = data['categories'];
        this.policyList = data['policies'];
        //return data;
      }
    );
  }

  toggleText(cID, active) {
    //var cID = document.getElementById("categoryID");
    var newDescription = document.getElementById("description_" + cID);
    var changeButton = (<HTMLInputElement>document.getElementById("change_" + cID)).value;
    if (changeButton === 'Change') {
      (<HTMLInputElement>document.getElementById("description_" + cID)).disabled = false;
      (<HTMLInputElement>document.getElementById("status_" + cID)).value = active;
      (<HTMLInputElement>document.getElementById("status_" + cID)).style.visibility = 'visible';
      (<HTMLInputElement>document.getElementById("lableStatus_" + cID)).style.visibility = 'hidden';
      (<HTMLInputElement>document.getElementById("change_" + cID)).setAttribute('value', 'Cancel');
      (<HTMLInputElement>document.getElementById("update_" + cID)).disabled = false;
    }
    else if (changeButton === 'Cancel') {
      (<HTMLInputElement>document.getElementById("description_" + cID)).disabled = true;
      (<HTMLInputElement>document.getElementById("status_" + cID)).style.visibility = 'hidden';
      (<HTMLInputElement>document.getElementById("lableStatus_" + cID)).style.visibility = 'visible';
      (<HTMLInputElement>document.getElementById("change_" + cID)).setAttribute('value', 'Change');
      (<HTMLInputElement>document.getElementById("update_" + cID)).disabled = true;
    }
  }

  connect(collectionViewer: CollectionViewer): Observable<Category[]> {
    return this.categorySubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.categorySubject.complete();
  }

  private getCategoryPolicies(pnumber) {
    this.categoryService.getCategoriesPolicies(this.apiCall + pnumber).subscribe(
      data => {
        this.categoryList = data['categories'];
        this.policyList = data['policies'];
      }
    );
  }

  onCreateConfirm(event: any): void {
    this.apiCall = '/spcategoryadd';
  };

  onSaveConfirm(event: any): void {

  };

  onDeleteConfirm(event: any): void {

  };
}
